export enum EventRequestTransactionResponseError {
  eventRequestSendError = 'eventRequestSendError',
  invalidEventRequestTransaction = 'invalidEventRequestTransaction',
  unknownError = 'unknownError',
}
